import script from "./DiningPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DiningPage.vue?vue&type=script&setup=true&lang=js"

import "./DiningPage.vue?vue&type=style&index=0&id=631fc59d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-631fc59d"]])

export default __exports__